<div class="photo-picker-wrapper">
  @if (!webcamOpen && (!cropperOpen || !cropperReady)) {
    <div
      class="flex flex-col items-center justify-center"
      >
      <app-loading-overlay [isLoading]="cropperOpen && !cropperReady">
        @if (!newImg && hasPrev) {
          <img
            [src]="prevImg"
            class="p-4 mb-4"
            [ngClass]="roundCropper ? 'small-avatar img-round' : 'photo-preview'"
            [style.aspect-ratio]="roundCropper ? null : aspectRatio"
            />
        }
        @if (newImg) {
          <img
            [src]="newImg"
            class="p-4 mb-4"
            [ngClass]="roundCropper ? 'small-avatar' : 'photo-preview'"
            [style.aspect-ratio]="roundCropper ? null : aspectRatio"
            />
        }
        @if (!newImg && !hasPrev && placeholderIcon) {
          <bv-icon
            [name]="placeholderIcon"
            class="photo-picker__placeholder-icon p-4 mb-4"
            style="font-size: 96px"
          ></bv-icon>
        }
        @if (!newImg && !hasPrev && !placeholderIcon && (fallbackUID || fallbackName)) {
          <app-member-avatar
            class="p-4 mb-4"
            [uid]="fallbackUID"
            [name]="fallbackName"
            [size]="fallbackSize"
          ></app-member-avatar>
        }
        @if (editable) {
          <div
            class="flex flex-row full-width pad-top items-center justify-center gap-4"
            >
            <app-file-input
              (select)="imageChange($event)"
              accept="image/*"
              >
              <bv-icon name="insert_photo"></bv-icon>
            </app-file-input>
            @if (!isDesktop) {
              <app-file-input
                (select)="imageChange($event)"
                accept="image/*"
                capture="environment"
                >
                <bv-icon name="photo_camera"></bv-icon>
              </app-file-input>
            }
            @if (isDesktop) {
              <button
                bv-button variant="primary"
                type="button"
                (click)="openWebcam()"
                >
                <bv-icon name="photo_camera"></bv-icon>
              </button>
            }
            @if (showDelete) {
              <button
                bv-button variant="danger" iconOnly
                (click)="onDelete.emit()"
                >
                <bv-icon name="delete"></bv-icon>
              </button>
            }
          </div>
        }
      </app-loading-overlay>
    </div>
  }
  @if (webcamOpen) {
    <div class="webcam-view">
      <video
        #videoRef
        autoplay
        playsinline
        muted
        class="webcam-video"
      ></video>
      <div class="webcam-controls">
        <button bv-button variant="primary" iconOnly size="lg" (click)="snap()">
          <bv-icon name="camera"></bv-icon>
        </button>
        @if (availableCameras().length > 1) {
          <button
            bv-button
            variant="secondary"
            iconOnly
            size="lg"
            (click)="switchCamera()"
            >
            <bv-icon name="cameraswitch"></bv-icon>
          </button>
        }
        <button bv-button variant="secondary" iconOnly size="lg" (click)="closeWebcam()">
          <bv-icon name="cancel"></bv-icon>
        </button>
      </div>
    </div>
  }
  @if (cropperOpen) {
    <div class="flex flex-col">
      <div class="cropper-wrapper">
        <image-cropper
          [imageBase64]="imgBase64"
          [maintainAspectRatio]="true"
          [aspectRatio]="aspectRatio"
          [resizeToWidth]="resizeToWidth"
          [onlyScaleDown]="true"
          [canvasRotation]="canvasRotation"
          (imageCropped)="imageCropped($event)"
          (imageLoaded)="imageLoaded()"
          (loadImageFailed)="loadImageFailed()"
          [roundCropper]="roundCropper"
          output="base64"
          format="jpeg"
        ></image-cropper>
      </div>
      @if (cropperReady) {
        <div class="full-width push-top text-center">
          <button bv-button variant="primary" iconOnly size="lg" (click)="crop()">
            <bv-icon name="crop"></bv-icon>
          </button>
          <button bv-button variant="secondary" iconOnly size="lg" (click)="rotateLeft()">
            <bv-icon name="rotate_90_degrees_ccw"></bv-icon>
          </button>
          <button bv-button variant="secondary" iconOnly size="lg" (click)="reset()">
            <bv-icon name="cancel"></bv-icon>
          </button>
        </div>
      }
    </div>
  }
</div>
